//#region src/common/fix-failed-to-execute-remove-child-on-node.ts
function e() {
	if (typeof Node == "function" && Node.prototype) {
		let e = Node.prototype.removeChild;
		Node.prototype.removeChild = function(t) {
			return t.parentNode === this ? e.apply(this, arguments) : (console && console.error("Cannot remove a child from a different parent", t, this), t);
		};
		let t = Node.prototype.insertBefore;
		Node.prototype.insertBefore = function(e, n) {
			return n && n.parentNode !== this ? (console && console.error("Cannot insert before a reference node from a different parent", n, this), e) : t.apply(this, arguments);
		};
	}
}
//#endregion
export { e as fixFailedToExecuteRemoveChildOnNode };
